import { KeywordFilteringGq } from '../../../graphql/projects/models/KeywordFilteringGq';
import { SerpStatusGq } from '../../../graphql/projects/models/SerpStatusGq';

/**
 * Converts a keyword filter to query string.
 * WARNING! Not all filters are implemented.
 */
export function paramsToKeywordFilter(searchParams?: string): Partial<KeywordFilteringGq> {
  let result: Partial<KeywordFilteringGq> = {
    domainRankFilters: [],
    tagFilters: [],
  };

  if (!searchParams?.length) return result;

  // Parse values
  let parsedParams = new URLSearchParams(searchParams);

  let domainValues: Record<number, Record<string, string>> = {};
  let tagValues: Record<number, Record<string, string>> = {};

  parsedParams?.forEach((urlValue, urlKey) => {
    // Serp filter
    if (urlKey.startsWith('serp')) {
      result.serpStatusFilter = [...(result.serpStatusFilter ?? []), urlValue as SerpStatusGq];
    }

    // Prepare tag values
    const tagKey = urlKey.match(/^tag\d+/gm);

    if (!!tagKey) {
      const tagIndex = +tagKey[0].slice('tag'.length);
      tagValues[tagIndex] = { ...tagValues[tagIndex] } ?? {};
      const cleanedKey = urlKey.slice(tagKey[0].length);
      tagValues[tagIndex][cleanedKey] = urlValue;
    }

    // Prepare domain values
    const domainKey = urlKey.match(/^domain\d+/gm);
    if (!!domainKey) {
      const domainIndex = +domainKey[0].slice('domain'.length);
      domainValues[domainIndex] = { ...domainValues[domainIndex] } ?? {};
      const cleanedKey = urlKey.slice(domainKey[0].length);
      domainValues[domainIndex][cleanedKey] = urlValue;
    }
  });

  // Apply tag filters
  Object.values(tagValues).map((tagValue) => {
    result.tagFilters.push({
      tagGroupId: +tagValue['GroupId'],
      tagId: tagValue['TagId'] === 'null' ? null : +tagValue['TagId'],
    });
  });

  // Apply domain filters
  Object.values(domainValues).map((domainValue) => {
    result.domainRankFilters.push({
      domainId: +domainValue['Id'],
      minRank: domainValue['MinRank'] === 'null' ? null : +domainValue['MinRank'],
      maxRank: domainValue['MaxRank'] === 'null' ? null : +domainValue['MaxRank'],
    });
  });

  return result;
}
